module.exports = __webpack_public_path__ + "img/2f_r_kokoro@2x.3d0ba8a3.png";